<template>
  <div>
    <Header page-type="top">
      <template v-slot:menu_left>
        <img src="../assets/img/logo.png" class="logo" alt="HACCP STATION">
      </template>

      <template v-slot:menu_center v-if="reportAlertButtonFlg">
        <div class="top_comment_alert">
          <p class="top_comment_alert_t">管理者からのコメントを確認してください</p>
          <a href="#" role="button" class="router-link-active" @click.prevent.stop="openNameListModal('report_alert')"><p class="top_comment_alert_l">ここをクリック</p></a>
        </div>
      </template>
      <template v-slot:menu_help>
            <a href="https://www.haccp-station-manual.com/" target="_blank" rel="noopener noreferrer" class="icn_back_black router-link-active"><p class="top_help">ヘルプ</p></a>
      </template>
      <template v-slot:menu_right>
        <a href="#" v-if="alertButtonFlg" role="button" @click.prevent.stop="openNameListModal('sensor_accident')" ><img src="../assets/img/inc_alert_on.png"></a>
        <a href="#" v-if="!alertButtonFlg" role="button" @click.prevent.stop="openNameListModal('sensor_accident')" ><img src="../assets/img/inc_alert_off.png"></a>
      </template>
    </Header>
    <TopMenu/>
    <div class="overlay" v-show="showModal.nameList">
      <div >
        <div class="modal_box wd720">
          <div class="modal_header_unit">
            <div class="modal_header_box">
              <p class="modal_header_tit">名前を選択してください</p>
            </div>
            <div class="modal_header_left">
              <a class="js-modal-close" role="button" @click.prevent.stop="dismiss('nameList')">キャンセル</a>
            </div>
            <div class="modal_header_right">
              <input class="modal_text_field" type="text" v-model="searchWord" placeholder="スタッフ名検索">
            </div>
          </div>
          <div class="modal_content_box">
            <ul>
              <li v-for="staff in filteredDatas" class="d-flex justify-content-between align-items-center" role="button" :key="staff.staffId" @click.prevent.stop="select(staff)">
                <div>
                  {{staff.staffName}}
                </div>
                <div>
                  <span v-if="selectedStaff && selectedStaff.staffId === staff.staffId"><i class="fas fa-check"></i></span>
                </div>
              </li>
            </ul>
          </div>
          <div class="btn_submit letter_spa">
            <a role="button" @click.prevent.stop="nextPage">決定</a>
          </div>
        </div>
      </div>
    </div>
    <div class="overlay" v-show="showModal.alertDisplay">
      <div>
        <div class="modal_box wd720">
          <div class="modal_header_unit">
            <div class="modal_header_box">
              <p class="modal_header_tit"><img src="../assets/img/inc_alert_on_header.png">警告</p>
            </div>
          </div>
          <div class="modal_content_tex">
            <p class="text_white_space_pre_wrap">{{this.message}}</p>
          </div>
          <div class="btn_submit">
            <a href="#" role="button" @click.stop.prevent="closeDisplay()">了解</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Header from '@/app/components/Header.vue'
import TopMenu from '@/app/components/TopMenu.vue'

export default {
  name: 'Top',
  components: {
    Header,
    TopMenu
  },
  computed:{
    brand: function () {
      return this.$store.getters['brand/data']
    },
    brandPath: function () {
      return this.$route.params.brandPath
    },
    filteredDatas:function(){
      var data = this.staffList;
      var filterWord = this.searchWord && this.searchWord.toLowerCase();
      if(filterWord){
        data = data.filter(function (row){
          return Object.keys(row).some(function (){
            return String(row["staffName"]).toLowerCase().includes(filterWord)
          })
        })
      }
      data = data.filter(function (row){
          return row["authorityKbn"] === 7;
      })
      return data;

    },
  },
  data: function () {
    return {
      selectedStaff: null,
      showModal: {
        nameList: false,
        alertDisplay:false,
        type:null,
      },
      alertData:{},
      dailyAlertData:{},
      alertButtonFlg:false,
      alertInfo:[
          //センサー異常
          {
            type:1,
            massage:"",
            isExists:false
          },
          //デイリーアラート
          {
            type:2,
            massage:"",
            isExists:false
          },
          //熱中症アラート
          {
            type: 3,
            massage: "",
            isExists: false
          },
      ],
      message:"",
      staffList: [],
      reportAlertButtonFlg:false,
      isButtonType:'',
      searchWord:'',
    }
  },
  created: function () {
    this.init()
  },
  methods:{

    init: async function () {

      let storeId = this.$store.getters['store/id']

      // システム管理者のときは警告を表示しない
      if (this.brandPath === process.env.VUE_APP_ADMIN_BRAND_PATH) {
        return
      }

      // 店舗情報がないときは警告を表示しない
      if (storeId === null || ! this.$cookies.get('user-api-token')) {
        return
      }
      else {

        let brandId = this.$store.getters['brand/id']
        let storeId = this.$store.getters['store/id']
        let accidentIconFlg = 0;

        // 警告情報 DBデータ取得
        try {
          const res = await this.$axios.get(this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/sensor_accident')
          this.alertData = res.data.sensorAccident;
          accidentIconFlg = res.data.accidentIconFlg;

          if (Object.keys(this.alertData).length) {
            // 未読の場合
            if(!this.alertData.readFlg){
              // メッセージ成形
              this.alertInfo[0].massage = this.changeMessage(this.alertData);
              this.alertInfo[0].isExists = true;
            }
          }
          // 警告有効
          if(accidentIconFlg){
            this.alertButtonFlg = true;
          }

          //熱中症のアラートがある場合
          this.heatIndexAlertData = res.data.heatStroke.accident;
          const wbgt = res.data.heatStroke.wbgt;
          const wbgtLabel = res.data.heatStroke.wbgtLabel;
          if (Object.keys(this.heatIndexAlertData).length) {
            // 未読の場合
            if(!this.heatIndexAlertData.readFlg){
              // メッセージ成形
              this.alertInfo[2].massage = "WBGT値:"+wbgt+"℃\n"+wbgtLabel+"\n"+this.heatIndexAlertData.detectionDate+" "+this.heatIndexAlertData.detectionTime+"\n"+this.heatIndexAlertData.location+"\n"+this.heatIndexAlertData.sensorId+"\n"+"温度："+this.heatIndexAlertData.detectionTemperature+"℃、湿度："+this.heatIndexAlertData.detectionHumidity+"%";
              this.alertInfo[2].isExists = true;
            }
          }

          const resReportCommentAlert = await this.$axios.get(this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/reportAlert/exists')
          const reportCommentAlertCount = resReportCommentAlert.data.reportCommentCount;
          if(reportCommentAlertCount > 0) {
            this.reportAlertButtonFlg = true;
          }

          const resCommentAlert = await this.$axios.get(this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/alert')

          this.dailyAlertData = resCommentAlert.data;
          if(this.dailyAlertData.isDailyResult || this.dailyAlertData.isCookingResult) {
            // メッセージ成形
            this.alertInfo[1].massage = "未実施の項目があります。\n";
            this.alertInfo[1].isExists = true;
            if(this.dailyAlertData.isDailyResult){
              this.dailyAlertData.dailyResult.forEach(button => {
                this.alertInfo[1].massage += "■"+button.buttonName+"\n"
                button.pages.forEach( page => {
                  this.alertInfo[1].massage += "・"+page+"\n"
                })
              })
            }
            if(this.dailyAlertData.isCookingResult){
              this.dailyAlertData.cookingResult.forEach(button => {
                this.alertInfo[1].massage += "■"+button+"\n"
              })
            }
            this.alertInfo[1].massage += "対応してください。"
          }
          if(this.alertInfo[0].isExists){
            this.message = this.alertInfo[0].massage;
            this.showModal.type = this.alertInfo[0].type;
            this.showModal.alertDisplay =true;
            return;
          }else if(this.alertInfo[1].isExists){
            this.showModal.type = this.alertInfo[1].type;
            this.message = this.alertInfo[1].massage;
            this.showModal.alertDisplay =true;
            return;
          } else if(this.alertInfo[2].isExists){
            this.showModal.type = this.alertInfo[2].type;
            this.message = this.alertInfo[2].massage;
            this.showModal.alertDisplay =true;
          }
        } catch (err) {
          let error = {
            button: {
              path: {name: 'top', params: {brandPath: this.brandPath}}
            }
          }

          if (err.customError) {
            error = Object.assign(error, err.customError)

            if (error.code == 403) {
              this.$cookies.set('user-api-token', '', 0)
              error.message = 'トップに戻ってもう一度ログインしてください。'
            }

            if (error.code == 401) {
              // 認証エラーの場合は店舗情報を削除して再ログインさせる
              this.$cookies.set('user-api-token', '', 0)
              this.$store.dispatch('store/doClear')
            }
          }
          this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
        }
      }
    },
    // 名前選択
    openNameListModal: async function (isButtonType) {
      this.isButtonType = '';
      let brandId = this.$store.getters['brand/id']
      let storeId = this.$store.getters['store/id']

      // 店舗情報を取得していないのに画面遷移しようとしたら警告
      if (storeId === null || ! this.$cookies.get('user-api-token')) {
        await this.$store.dispatch('dialog/setDialog', {
          title: '店舗情報取得エラー',
          text: 'スタッフ画面を表示できません。\n管理画面へアクセスし、\n店舗管理者のログイン操作を実施してください。',
          button: {
            cancel: {show: false, text: null},
            done: {show: true, text: '閉じる'}
          },
          next: null,
          show: true,
        })

        return
      }

      // ユーザ一覧 DBデータ取得
      try {
        const res = await this.$axios.get(this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/staff')
        this.staffList = res.data.staffList
      } catch (err) {
        let error = {
          button: {
            path: {name: 'top', params: {brandPath: this.brandPath}}
          }
        }

        if (err.customError) {
          error = Object.assign(error, err.customError)
        }
        this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
      }

      this.showModal.nameList = true
      this.isButtonType = isButtonType;
    },
    // キャンセル
    dismiss: function (type) {
      this.showModal[type] = false
      if (type === 'nameList') {
        this.selectedButton = null
        this.selectedStaff = null
      }
      if (type === 'reportCommentAlertLogin') {
        this.loginError = ''
        this.pwText = ''
      }
    },
    select: function (staff) {
      this.selectedStaff = staff
    },
    nextPage: function () {
      // 選択中スタッフ
      this.setRequestStaff(this.selectedStaff.staffId, this.selectedStaff.staffName)
      this.$store.dispatch('staff/doUpdate', this.selectedStaff)

      switch (this.isButtonType) {
        case "sensor_accident":
          this.$router.push({name: 'alertListIndex'});
          break;
        case "report_alert":
          this.$router.push({name: 'reportCommentAlertListIndex', params: { brandPath: this.brandPath}});
          break;
      }

    },
    setRequestStaff: function (userId, userName) {
      const userInfo = this.brand.company_name + ' ' + this.brand.brand_name + ' ' + this.$store.getters['store/name'] + ' ' + userId + ' ' + userName
      this.setRequester('STAFF', userInfo)
    },
    setRequester: function (type, info) {
      let user = {}
      user.type = type
      user.info = info
      this.$store.dispatch('user/setUser', user)
    },
    changeMessage(alertData){

      var messageStr = "";

      // typeの変換 アラート種別:1:温度異常、2:湿度異常、3:GW異常、4:機器異常
      if(this.alertData.type === 1 && this.alertData.status === 1){
        messageStr = this.alertData.location + " 温度上限異常"
      }
      else if(this.alertData.type === 1 && this.alertData.status === 2){
        messageStr = this.alertData.location + " 温度下限異常"
      }
      else if(this.alertData.type === 2 && this.alertData.status === 1){
        messageStr = this.alertData.location + " 湿度上限異常"
      }
      else if(this.alertData.type === 2 && this.alertData.status === 2){
        messageStr = this.alertData.location + " 湿度下限異常"
      }
      else if(this.alertData.status === 3){
        messageStr = "通信機\n電源ケーブル抜けの可能性\nケーブルが機器、コンセントに接続しているかご確認ください\n\n※当異常が頻発する場合には、原田産業㈱までご連絡ください。"
                + "\n\n原田産業㈱\nフードセーフティーチーム\n03-3213-8293\n（平日　9:00-17:30）"
      }
      else if(this.alertData.type === 4 && this.alertData.status === 4){
        messageStr = this.alertData.location + " 温度センサー\n電池残1ヵ月\n\n近日中に交換品を配送します。届き次第、同封の手順書に従い対象の機器のセンサーを交換してください。"
      }
      else if(this.alertData.type === 4 && this.alertData.status === 5){
        messageStr = this.alertData.location + " 温度センサー\n電池残3ヵ月\n\n交換品の手配を開始します。電池残量約1カ月前に交換品を発送し、発送通知を送ります。"
      }
      else if(this.alertData.type === 5 && this.alertData.status === 6){
        messageStr = this.alertData.location + " 温湿度データ欠落\n\n温湿度データが確認できません。以下に異常がないか、チェックしてください。\n・センサーの電源がオンになっている\n・通信用ゲートウェイ下部のスイッチがオンになっている\n・通信用ゲートウェイの電源アダプターやケーブルが抜けていない" +
                "\n\nしばらく経っても復帰メールが来ない場合、下記までお問い合わせください。"
                + "\n\n原田産業㈱\nフードセーフティーチーム\n03-3213-8293\n（平日　9:00-17:30）"
      }


      // 不具合確認時刻
      if(alertData.type === 1 ){
        messageStr = messageStr + "\n\n不具合確認時刻 " + this.alertData.detectionDate + " "  + this.alertData.detectionTime + " " + this.alertData.detectionTemperature + "℃";
      }
      else if(alertData.type === 2){
        messageStr = messageStr + "\n\n不具合確認時刻 " + this.alertData.detectionDate + " " + this.alertData.detectionTime + " " + this.alertData.detectionHumidity + "％";
      }
      else{
        messageStr = messageStr + "\n\n不具合確認時刻 " + this.alertData.detectionDate + " " + this.alertData.detectionTime  ;
      }

      return messageStr;
    },
    async closeDisplay() {
      this.showModal.alertDisplay = false;

      // 既読処理の呼び出し
      var brandId = this.$store.getters['brand/id'];
      var storeId = this.$store.getters['store/data'].store_id;
      var url = "";
      var data ={};
      if(this.showModal.type == 1) {
        url = this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/sensor_accident/read';
        data = {sensor_accident_id: this.alertData.sensorAccidentId};
      }else if(this.showModal.type == 2) {
        url = this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/alert/read';
        data = {isUpdateDailyAlert: this.dailyAlertData.isDailyResult, daily_alert_ids:this.dailyAlertData.dailyAlertIds, isUpdateCookingAlert: this.dailyAlertData.isCookingResult,cooking_alert_ids:this.dailyAlertData.cookingAlertIds,};
      } else if(this.showModal.type == 3){
        url = this.$apiEndpoint + 'user/brand/' + brandId + '/store/' + storeId + '/sensor_accident/read';
        data = {sensor_accident_id: this.heatIndexAlertData.sensorAccidentId};
      }

        //更新API呼び出し
        await this.$axios
            .post(url, data)
            .then()
            .catch((err) => {
              let error = {
                button: {
                  path: {name: 'top', params: {brandPath: this.brandPath}}
                }
              }
              if (err.customError) {
                error = Object.assign(error, err.customError);

                if (error.code == 400) {
                  this.validationMessage = error.message;
                }
              }
              if (error.code !== 400) {
                this.$store.dispatch('error/setError', error).then(this.$router.push({name: 'error'}))
              }
            });
      //アラートがセンサー異常とデイリー異常２つある場合は、続けてデイリー異常のアラートを表示
      if(this.showModal.type == 1 && this.alertInfo[0].isExists && this.alertInfo[1].isExists) {
        this.showModal.type = this.alertInfo[1].type;
        this.message = this.alertInfo[1].massage;
        this.showModal.alertDisplay =true;
      } else if(this.showModal.type == 2 && this.alertInfo[1].isExists && this.alertInfo[2].isExists){
        this.showModal.type = this.alertInfo[2].type;
        this.message = this.alertInfo[2].massage;
        this.showModal.alertDisplay =true;
      }
    },
  }
}
</script>
